<template>

    <div id="app">
        <Header></Header>
        <Hero :height="550" image="/static/img/what.jpg"></Hero>
        <Services></Services>
        <Footer></Footer>
    </div>


</template>

<script>

    import Header from "./components/Header";
    import Footer from "./components/Footer";
    import Hero from "./components/Hero";
    import BlockC from "./components/BlockC";
    import Services from "./components/Services";

    export default {
        name: 'app',

        data: () => ({}),
        components: {
            Services,
            BlockC,
            Hero,
            Footer,
            Header,


        }
    }
</script>
